import useToggle from '@lyearn/core/hooks/useToggle';
import { useTranslation } from '@lyearn/i18n';
import { CloseOutline } from '@lyearn/icons';
import { IconButton, Loader, Tooltip } from '@lyearn/ui';
import { useGenerativeTaskContext } from '@/components/LyearnAI/context/generativeTaskContext';

import { aiButtonIconColor, aiLoaderStyles } from './styles';

interface StopGeneratingIconProps {
  className?: string;
}

const StopGeneratingIcon: React.FC<StopGeneratingIconProps> = (props) => {
  const { className } = props;
  const [isHovering, { on, off }] = useToggle(false);
  const { t } = useTranslation();
  const { cancelGenerativeTask } = useGenerativeTaskContext();

  return (
    <Tooltip title={t('AI:StopGenerating')}>
      <IconButton
        appearance="secondary"
        className={className}
        shape="square"
        size="s"
        variant="ghost"
        onClick={cancelGenerativeTask}
        onMouseEnter={on}
        onMouseLeave={off}>
        {isHovering ? (
          <CloseOutline className={aiButtonIconColor} />
        ) : (
          <Loader className={aiLoaderStyles} size={20} />
        )}
      </IconButton>
    </Tooltip>
  );
};

export default StopGeneratingIcon;
